// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getQuote, GetQuoteApiParameter } from "@insite/client-framework/Services/QuoteService";
import { chain, RequestDataFromApi } from "@insite/client-framework/Store/Data/Quotes/Handlers/LoadQuote";
import { QuoteModel } from "@insite/client-framework/Types/ApiModels";
import { getQuote as getRealTimeQuote } from "@mcmc/App/Services/QuoteService";
import { getDateNoTimeZone } from "@mcmc/XDL/Utilities";

interface Parameter extends GetQuoteApiParameter {
    isRealTime: boolean;
    onError?: (error?: string) => {};
}

type HandlerType = ApiHandler<Parameter, QuoteModel>;

export const CustomRequestDataFromApi: HandlerType = async props => {
    try {
        if (props.parameter.isRealTime) {
            props.apiResult = await getRealTimeQuote(props.apiParameter.quoteId);
        } else {
            props.apiResult = await getQuote(props.apiParameter);
        }
        props.apiResult.orderDate = getDateNoTimeZone(props.apiResult.orderDate);
        props.apiResult.expirationDate = getDateNoTimeZone(props.apiResult.expirationDate);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Data/Quotes/FailedToLoadQuote",
                quoteId: props.parameter.quoteId,
                status: 404,
            });
            return false;
        }
        props.parameter.onError?.(error && ((error.errorJson && error.errorJson.message) || error.errorMessage));
        throw error;
    }
};

replaceInChain(chain, RequestDataFromApi, CustomRequestDataFromApi);
export const getQuoteChain = chain;
